import {connect} from "react-redux"
import {Dispatch} from "@reduxjs/toolkit"
import {createSelector} from "reselect"
import {DIGIT_REGEX} from "../../config/constants"
import {handleSetFacetAction} from "../../ducks/viewAllModal"
import {FacetsAlphabetValues, FacetState} from "../../models/FacetsState"
import State from "../../models/State"
import deburr from "../../utils/deburr"

const selectViewAllModal = (state: State) => state.viewAllModal

const makeSelectFacets = createSelector([selectViewAllModal], viewAllModal => {
    let facets: FacetState[]
    switch (viewAllModal.activeCharacter) {
        case FacetsAlphabetValues.Numeric: {
            facets = Object.values(viewAllModal.facets).filter(eachFacet => !!DIGIT_REGEX.exec(eachFacet.n))
            break
        }
        case FacetsAlphabetValues.All: {
            facets = Object.values(viewAllModal.facets)
            break
        }
        default: {
            facets = Object.values(viewAllModal.facets).filter(
                eachFacet => !!deburr(eachFacet.n).toLowerCase().startsWith(viewAllModal.activeCharacter.toLowerCase()),
            )
        }
    }
    return facets
})

export const mapStateToProps = (state: State) => ({
    facets: makeSelectFacets(state),
})

export const mapDispatchToProps = dispatch => ({
    handleSetFacet: (facetValue: string) => dispatch(handleSetFacetAction(facetValue)) as Dispatch,
})

export default connect(mapStateToProps, mapDispatchToProps)
